import React, { FunctionComponent, useState } from 'react'
import { useSelector, RootStateOrAny } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Mobile, Desktop } from 'Shared/components/Responsive'
import { Hint } from 'Stories/Hint/Hint.stories'
import { HintGuide } from 'Stories/HintGuide/HintGuide.stories'
import { renderRole } from 'Constants/functions'
import ava from 'Shared/img/ava.png'
import { WhiteGreenBtn } from 'Stories/Button/Button.stories'
import { IconQuestionMark } from 'Stories/Icon/Icon.stories'
import { Roles } from 'Constants/enums'
import {
  getUserSelector,
  getUserRole,
  getIsArtist,
  getVerified,
} from 'Redux/selectors/auth'
import { SideBarTopProps } from './SideBarTopProps'
import { User } from '../../../../../Types'
import AccountValidationModal from '../AccountValidationModal'
import AccountValidation from '../AccountValidation'
import {
  HintValidationPortal,
  GotItContainer,
  SidebarAvatar,
  SidebarImg,
  SidebarTitleName,
  SidebarTitleRole,
  ValidationBlock,
  ValidationText,
  DeactivatedLabel,
} from './styles'

const SideBarTop: FunctionComponent<SideBarTopProps> = ({
  collapse,
  isDefaultImage,
  onImageLoadError,
}) => {
  const { t } = useTranslation()
  const user: User = useSelector(getUserSelector)
  const userRole: Roles = useSelector(getUserRole)
  const isArtist: boolean = useSelector(getIsArtist)
  const isVerified: boolean = useSelector(getVerified)
  const isDeactivated: boolean = useSelector(
    (state: RootStateOrAny) => state.auth.user.isDeactivated
  )

  const [modal, setModalValue] = useState(false)
  const [hintGuide, setHint] = useState({ component: null, name: null })
  // @ts-ignore
  const handleSetHint = hint => {
    if (hint === 'hintValidation') {
      // @ts-ignore
      setHint({ component: <AccountValidation />, name: 'hintValidation' })
    }

    if (hint === 'clearHint') {
      setHint({ component: null, name: null })
    }
  }

  return (
    <>
      {!collapse ? (
        <SidebarAvatar>
          <SidebarImg
            alt="avatar"
            src={isDefaultImage ? ava : user.user_photo_url}
            onError={onImageLoadError}
          />
          <SidebarTitleName>
            {user.first_name} {user.last_name}
          </SidebarTitleName>
          <SidebarTitleRole>{renderRole(userRole, t)}</SidebarTitleRole>
          {isDeactivated && (
            <DeactivatedLabel>({t('sidebar.deactivated')})</DeactivatedLabel>
          )}
          {!isArtist && !isVerified && userRole !== Roles.influencer ? (
            <ValidationBlock>
              <ValidationText>
                {t('sidebar.accountOnValidation')}
              </ValidationText>
              <Desktop>
                <HintGuide
                  hintName="hintValidation"
                  setHintName={handleSetHint}
                  currentHint={hintGuide && hintGuide.name}
                />
                {hintGuide && hintGuide.component && (
                  <HintValidationPortal>
                    {hintGuide.component}
                    <GotItContainer>
                      <WhiteGreenBtn
                        color="whiteGreen"
                        onClick={() => handleSetHint('clearHint')}
                      >
                        {t('scheduleCampaignPage.gotIt')}
                      </WhiteGreenBtn>
                    </GotItContainer>
                  </HintValidationPortal>
                )}
              </Desktop>

              <Mobile>
                <Hint
                  // @ts-ignore
                  onClick={setModalValue}
                >
                  <IconQuestionMark />
                </Hint>
                <AccountValidationModal isOpen={modal} toggle={setModalValue} />
              </Mobile>
            </ValidationBlock>
          ) : null}
        </SidebarAvatar>
      ) : null}
    </>
  )
}

export default SideBarTop
